<div class="flex w-full min-h-full">
    <app-main-left-sidebar class="flex-shrink-0"></app-main-left-sidebar>
    <main class="flex-grow overflow-hidden bg-[#F5F5F5]" [ngStyle]="{'background-color': bgColor}">
        <router-outlet></router-outlet>
    </main>
</div>

@if (createDashboardService.isOpen()) {
  <app-create-dashboard (close)="onCloseCreateDashboard($event)"></app-create-dashboard>
}